import React from 'react'
import LOGO_YELLOW_GIVU from '../../styles/images/logo_yellow.png'
import { useNavigate } from 'react-router-dom'

const MainLogoImg = () => {
  const navigate = useNavigate()
  return (
    <img src={LOGO_YELLOW_GIVU} alt="Main Logo Image" className='mx-9 mt-2 hover:cursor-pointer select-none	' onClick={()=>navigate('/')} width={110}/>
  )
}

export default MainLogoImg